import { IPreloadedState } from 'shared/types/redux';

export const selectAreTagsHidden = (state: IPreloadedState) => state.tags.isHidden;
